export default __webpack_public_path__ + "static/media/startRecorder.2a01cdd6.svg";